module.exports = __webpack_public_path__ + "ddace9244b98654921dbe40b92823b89.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/reading/teachers-picks-online.png
// module id = 3419
// module chunks = 0